module.exports = __webpack_public_path__ + "static/BLOG_AIFeatures_Blog-ed2f84d7b1217fdba9536a60e2925427.webp";